import { useEffect, useState } from 'react';
// import { mockClientData } from '../data/mockData';
import type { ClientData, ClientResponse } from '../types';
import { formatClient, getLegacyBaseUrl } from '../utils';

const useClientApi = (
  clientId: string,
): { client?: ClientData; loading: boolean; error?: Error } => {
  const [client, setClient] = useState<ClientData>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error>();

  useEffect((): void => {
    if (!clientId) return;
    setLoading(true);
    fetch(`${getLegacyBaseUrl()}/api/v1/client.json/${clientId}`, {
      method: 'GET',
      credentials: 'include',
    })
      .then(response => {
        if (!response?.ok) throw new Error(response.status.toString());
        return response.json();
      })
      .then((response: ClientResponse) => formatClient(response))
      .then((data: ClientData) => setClient(data))
      .catch((error: Error) => {
        /* eslint-disable no-console */
        console.log('Failed to fetch client data:', error.message);
        // setClient(mockClientData);
        setError(error);
      })
      .finally(() => setLoading(false));
  }, [clientId]);

  return { client: { ...client, clientId } as ClientData, loading, error };
};

export default useClientApi;
